import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element, {
      backdrop: 'static'
    });
  }

  open(e) {
    if (!this.modal.isOpened) {
      this.modal.show();
    }
  }

  hide() {
    this.modal.hide();
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide();
    }
  }
}
